import React from 'react';
import { ConfigurationPanel } from '../components/ConfigurationPanel';

export const ConfiguracionPage: React.FC = () => {
  return <ConfigurationPanel />;
};
